import $http from "@/api/index";
/**
 * 保存表结构
 * @param {*} databaseLinkId 连接串Id
 * @param {*} draftId 草稿串Id
 * @param {*} tableName 表名称
 * @param {*} tableRemark 表描述
 * @param {*} strColList 表字段
 */
export function SaveTable(
  databaseLinkId,
  draftId,
  tableName,
  tableRemark,
  strColList
) {
  let getUrl = {
    method: "POST",
    url: `DatabaseTable/SaveTable?databaseLinkId=${databaseLinkId}&draftId=${draftId}&tableName=${tableName}&tableRemark=${tableRemark}&strColList=${strColList}`,
    requestType: 1
  };
  let para = {
    // databaseLinkId,
    // draftId,
    // tableName,
    // tableRemark,
    // strColList
  };
  return $http(getUrl, para);
}

/**
 * 保存表数据
 * @param {*} databaseLinkId 连接串Id
 * @param {*} tableName 表名称
 * @param {*} formData 表字段值
 * @param {*} keyValue 主键(为空新增 不为空修改)
 * @param {*} isEdit
 */
export function SaveTableData(
  databaseLinkId,
  tableName,
  formData,
  keyValue,
  isEdit = true
) {
  console.log("SaveTableData formData", formData);
  keyValue = keyValue === undefined ? "" : keyValue;
  let getUrl = {
    method: "POST",
    url: `DatabaseTable/SaveTableData?databaseLinkId=${databaseLinkId}&tableName=${tableName}&formData=${formData}&keyValue=${keyValue}&isEdit=${isEdit}`,
    requestType: 1
  };
  let para = {
    // databaseLinkId,
    // tableName,
    // formData,
  };
  console.log("SaveTableData getUrl", getUrl);
  return $http(getUrl, para);
}

/**
 * 保存表数据
 * @param {*} databaseLinkId 连接串Id
 * @param {*} tableName 表名称
 * @param {*} formData 表字段值
 * @param {*} keyValue 组件ID
 */
export function GetTableList(databaseLinkId, tableName, keyValue) {
  keyValue = keyValue === undefined ? "" : keyValue;
  let getUrl = {
    method: "GET",
    url: `DatabaseTable/GetTableDataAllList?databaseLinkId=${databaseLinkId}&tableName=${tableName}&keyValue=${keyValue}`,
    requestType: 1
  };
  let para = {
    // databaseLinkId,
    // tableName,
    // formData,
  };
  return $http(getUrl, para);
}

/**
 * 拷贝创建多条审批流程新数据
 * @param {*} databaseLinkId
 * @param {*} TaskModeList
 */
export function CopyFLowOrForm(databaseLinkId, TaskModeList) {
  let getUrl = {
    method: "POST",
    url: `DatabaseTable/CopyFLowOrForm?databaseLinkId=${databaseLinkId}`,
    requestType: 1,
    isJsonData: true
  };
  return $http(getUrl, TaskModeList);
}
